import { exponentialBackoff } from './Api'
import { Log } from '@lightningjs/sdk'

export class Socket {
  constructor(url, brand, onMessage, onError) {
    this.url = url
    this.brand = brand
    this.onMessage = onMessage
    this.onError = onError
    this.clientSocket = null
    this.retryingConnection = false
    this._lastBrand = undefined
  }

  heartbeat() {
    /* Checks for presence of server every 30 seconds */
    if (!this.clientSocket) {
      return
    }

    if (this.clientSocket.readyState !== 1) {
      return
    }

    this.clientSocket.send('heartbeat')

    setTimeout(this.heartbeat, 30000)
  }

  subscribe(brand) {
    this.clientSocket.send(JSON.stringify({ actions: [{ type: 'subscribe', station: brand }] }))
  }

  open(/*e,*/ brand) {
    if (this._lastBrand) {
      this.unsubscribe(this._lastBrand)
      this._lastBrand = undefined
    }

    this._lastBrand = brand
    this.subscribe(brand)

    this.heartbeat()
  }

  error(close = true) {
    if (this.onError) {
      this.onError()
    }

    if (!this.retryingConnection) {
      this.reconnect(close)
    }
  }

  reconnect(close) {
    this.retryingConnection = true

    Log.info('Socket reconnnecting')

    if (close) {
      this.close()
    }
    exponentialBackoff(
      this.isConnected.bind(this),
      8,
      1000,
      () => {
        this.retryingConnection = false
        Log.info('Socket reconnected')
      },
      () => {
        Log.warn('Unable to reconnect')
      },
      true
    )
  }

  unsubscribe(brand) {
    this.clientSocket.send(JSON.stringify({ actions: [{ type: 'unsubscribe', station: brand }] }))
  }

  isConnected() {
    if (
      this.clientSocket.readyState !== WebSocket.OPEN ||
      this.clientSocket.readyState !== WebSocket.CONNECTING ||
      this.clientSocket.readyState === WebSocket.CLOSED
    ) {
      this.connect()

      return this.clientSocket.readyState === WebSocket.OPEN
    }

    return this.clientSocket.readyState === WebSocket.OPEN
  }

  close() {
    this.clientSocket.close()
  }

  connect() {
    if (this.clientSocket === null || this.clientSocket.readyState === WebSocket.CLOSED) {
      this.clientSocket = new WebSocket(this.url)

      this.clientSocket.addEventListener('open', () => this.open(this.brand))
      this.clientSocket.addEventListener('error', this.error)
      this.clientSocket.addEventListener('close', this.error(false))

      return this.clientSocket
    }
  }
}
